import {
  ChangeDetectorRef,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDateBoxModule, DxFileUploaderModule, DxFormComponent, DxFormModule, DxLoadPanelModule, DxNumberBoxModule, DxScrollViewModule, DxSelectBoxModule, DxTextBoxModule, DxToolbarModule } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { FormPhotoComponent } from './shared-components/form-photo/form-photo.component';
import { ProfileCardComponent } from './shared-components/profile-card/profile-card.component';
import { getSizeQualifier, ScreenServiceService } from './shared-services/screen-service.service';
import { DataServicesService } from './shared-services/data-services.service';
import { Router } from '@angular/router';
import { FormLabelMode, LabelLocation } from 'devextreme/ui/form';
import { DkGlobalUserSettingsService } from '../../services/dk-global-user-settings.service';
import { PasswordPopupComponent } from './shared-components/password-popup/password-popup.component';
import { UtilsService } from '../../services/utils.service';
import { ChangePasswordPopupComponent } from "./shared-components/change-password-popup/change-password-popup.component";
import { KullaniciBilgiDto, PersonelBilgiDto } from '../../models/ortak.dtos';
import { UserInformationService } from '../../services/user-informations.service';
import { GenOrtManuelService } from 'libs/gen/src/lib/services/moduls-manuel-services/ort/gen-ort-manuel.service';
import { GetResim_Request, ResimSourceType } from '../../../../../../../libs/gen/src/lib/models/genpg.models';
import { AuthService } from '@dabnet-kamu/libs/auth';
import { ThemeService } from '../../theme/theme.service';

@Component({
    selector: 'dk-hesabim',
    standalone: true,
    templateUrl: './hesabim.component.html',
    styleUrls: ['./hesabim.component.scss'],
    imports: [CommonModule, DxToolbarModule, DxButtonModule, DxSelectBoxModule,
        DxTextBoxModule, DxFormModule, DxNumberBoxModule, DxDateBoxModule, DxLoadPanelModule,
        DxFileUploaderModule, DxScrollViewModule, ProfileCardComponent, FormPhotoComponent,
        DxFileUploaderModule, PasswordPopupComponent, ChangePasswordPopupComponent]
})
export class HesabimComponent implements OnInit {
  @ViewChild('form', { static: true }) form: DxFormComponent;

    
  public imageUrl = "assets/temp-profile-example.png"
  

  profileId = 22;

  profileData: Record<string, any>;

  savedProfileData: Record<string, any>;

  isLoading = true;

  supervisorsList:any[] = [];

  isChangePasswordPopupOpened = false;

  isDataChanged = false;

  isContentScrolled = false;

  basicInfoItems: Record<string, any>[] = this.getBasicInfoItems();

  contactItems: Record<string, any>[] = this.getContactItems();

  addressItems: Record<string, any>[] = this.getAddressItems();

  userInfo: KullaniciBilgiDto;

  getSizeQualifier = getSizeQualifier;

  labelMode:FormLabelMode = this.globalUserSettings.globalLabelMode;
  labelLocation:LabelLocation = this.globalUserSettings.globalLabelLocation;

  // ---- Hesabım yenileme (02.10.2026) ----
  /** Kullanıcıya bağlı personel kaydı (yoksa null). */
  personel: PersonelBilgiDto | null = null;
  personelYuklendi = false;
  /** Personel kaydındaki fotoğraf (data URI); yoksa baş harfler. */
  foto: string | null = null;

  constructor(private router:Router, private service: DataServicesService, public screen: ScreenServiceService, private ref: ChangeDetectorRef,
    public elRef:ElementRef,private globalUserSettings:DkGlobalUserSettingsService,private utilsService:UtilsService,
    private userService: UserInformationService, private ortManuelService: GenOrtManuelService,
    private authService: AuthService, private themeService: ThemeService
  ) {
  }

  ngOnInit(): void {

    this.userInfo = JSON.parse(localStorage.getItem('kullanici') || '{}');
    this.personelYukle();
  }

  /** Personel kaydı ve fotoğrafı (ana ekrandaki kartla aynı kaynaklar). */
  private async personelYukle() {
    try {
      const res = await this.userService.getPersonelInfo();
      const p = res?.response?.result ? res.response.personelBilgi : null;
      this.personel = p?.personelKod && p.personelTurKod !== 0 ? p : null;
      if (this.personel) {
        const resim = await this.ortManuelService.GetResim_Request(
          new GetResim_Request({ resimKod: this.personel.personelKod, sourceType: ResimSourceType.personel, base64Yn: 1 })
        );
        if (resim?.response?.result && resim.response.base64) this.foto = this.dataUri(resim.response.base64);
      }
    } catch {
      this.personel = null;
    } finally {
      this.personelYuklendi = true;
    }
  }

  private dataUri(base64: string): string {
    return base64.startsWith('data:') ? base64 : `data:image/jpeg;base64,${base64}`;
  }

  get adSoyad(): string {
    const p = this.personel;
    return (p ? `${p.ad ?? ''} ${p.soyad ?? ''}` : `${this.userInfo?.adi ?? ''} ${this.userInfo?.soyadi ?? ''}`).trim() || this.userInfo?.kullaniciAd || '';
  }

  get basHarfler(): string {
    return this.adSoyad.split(/\s+/).filter(Boolean).slice(0, 2).map((x) => x[0]).join('').toLocaleUpperCase('tr');
  }

  get maskeliTckn(): string {
    const t = String(this.personel?.tckn ?? '');
    return t.length >= 5 ? `${t.slice(0, 3)} *** ** ${t.slice(-2)}` : t;
  }

  get temaAdi(): string {
    return this.themeService.getCurrentThemeName();
  }

  /** Personel fotoğrafını dosya olarak indirir. */
  fotografiIndir() {
    if (!this.foto) return;
    const tur = /^data:image\/(\w+)/.exec(this.foto)?.[1] ?? 'jpeg';
    const a = document.createElement('a');
    a.href = this.foto;
    a.download = `${(this.adSoyad || 'fotograf').replace(/\s+/g, '_')}.${tur === 'jpeg' ? 'jpg' : tur}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  oturumuKapat() {
    this.authService.logout();
  }

  goBack() {
    this.router.navigate(['/main/dabnet']);
  }

  onFieldChange(fieldName?:any, value?:any) {
    // Form referansı kontrolü - form henüz initialize olmamış olabilir
    if (!this.form || !this.form.instance) {
      return;
    }

    const {isValid} = this.form.instance.validate();

    if (!isValid) {
      return;
    }

  /*   if (fieldName) {
      this.cardData[fieldName] = value;
    }

    this.dataChanged.emit(this.cardData); */
  }

  getBasicInfoItems(){
    return [
      { dataField: 'firstName', colSpan: 2 },
      { dataField: 'lastName', colSpan: 2 },
      {
        dataField: 'department',
        editorType: 'dxSelectBox',
        colSpan: 1,
        editorOptions: {
          items: ['UI/UX', 'Backend Developers'],
        }
      },
      {
        dataField: 'position',
        editorType: 'dxSelectBox',
        colSpan: 1,
        editorOptions: {
          items: ['Designer', 'Developer', 'Technical Writer'],
        }
      },
      {
        dataField: 'hiredDate',
        editorType: 'dxDateBox',
        colSpan: 1,
        editorOptions: {
          max: new Date(),
        }
      },
      {
        dataField: 'birthDate',
        colSpan: 1,
        editorType: 'dxDateBox',
        editorOptions: {
          max: new Date(),
        }
      },
    ]
  }

  getContactItems() {
    return [
      {
        dataField: 'phone',
        editorOptions: {
          mask: '+1(000)000-0000',
        }
      },
      {
        dataField: 'email',
        validators: [
          {type: 'email'}
        ]
      },
      {
        dataField: 'domainUsername',
        colSpan: 2,
      },
      {
        dataField: 'status',
        colSpan: 2,
      },
      {
        dataField: 'supervisor',
        label: 'Supervisor',
        colSpan: 2,
        itemsList: this.supervisorsList,
        editorType: 'dxSelectBox',
      },
    ];
  }

  getAddressItems() {
    return [
      { dataField: 'country' },
      { dataField: 'city' },
      {
        dataField: 'state',
        colSpan: 2,
        label: 'State/province/area',
        editorOptions: {
          label: 'State/province/area',
        }
      },
      {
        dataField: 'address',
        colSpan: 2,
      },
      {
        dataField: 'zipCode',
        editorType: 'dxNumberBox',
        colSpan: 2,
      },
    ];
  }

  dataChanged() {
    this.isDataChanged = true;
  }

  setSavedData(data = this.profileData) {
    this.savedProfileData = JSON.parse(JSON.stringify(data));
  }

  copyToClipboard(text:string, evt:any) {
    window.navigator.clipboard?.writeText(text);
    const tipText = 'Kopyalandı!';
    notify({
        message: tipText,
        minWidth: `${tipText.length + 2}ch`,
        width: 'auto',
        position: {of: evt.target, offset:'0 -30'}
      },
      'info', 500);
  };

  changePassword() {
    console.log('tik')
    this.isChangePasswordPopupOpened = true;
  };

  cancel() {
    this.profileData = this.savedProfileData;
    this.ref.detectChanges();
    this.setSavedData();

    setTimeout(() => {
      this.isDataChanged = false;
    });
  }

  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }

}
